<template>
	<div class="class-name">
		<layout-gray class="col" gutter="20">
			<Upper18Team v-for="(story,i) in createStories" :key="i" :ref="'story'" :num="i" :story="story" :isOnly="(createStories.length == 1)? true : false"></Upper18Team>
			<el-button icon="new-button el-icon-circle-plus" @click="addNewStoreis" type="primary" plain>再新增一個小組</el-button>
			<!-- <div class="col" align-x="center">
				<el-checkbox v-model="confirmed">我確定此組別成員為國中（含）以上之同學</el-checkbox>
				<br>
				<small>若為國小（含）以下組別請報名：<a href="https://dfcchallenge.merrymama.org.tw/">小學生公益行動 DFC 挑戰</a></small>
			</div> -->
			<div class="row" align-x="right" gutter="10">
				<el-button type="primary" size="mini" @click="nextStep">下一步</el-button>
			</div>
		</layout-gray>
	</div>
</template>

<script>
import LayoutGray from "@/components/challenge/signUp/LayoutGray.vue";
import Upper18Team from "@/components/challenge/signUp/Upper18Team.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import uuid from "uuid";

export default {
	components: { LayoutGray, Upper18Team },
	data() {
		return {
			// confirmed: false
		};
	},
	computed: {
		...mapState("story", ["createStories"])
	},
	methods: {
		...mapMutations("story", ["addNewCreateStories", "cleanCreateStories"]),
		...mapActions("story", ["createStory"]),
		addNewStoreis() {
			// 18歲以下
			// index用來vue render用 再發API前會移除
			let data = { index: uuid.v4(), is_18: true };
			this.addNewCreateStories(data);
		},
		initStories() {
			// 18歲以下
			let data = { index: uuid.v4(), is_18: true };
			this.cleanCreateStories();
			this.addNewCreateStories(data);
		},
		async nextStep() {
			for (let ref of this.$refs.story) {
				if (!ref.validatedAll()) {
					this.$message.error("資料尚未全部填寫完畢");
					return;
				}
			}
			try {
				// if (!this.confirmed) throw "請勾選「我確定此組別成員為國中（含）以上之同學」"
				await this.createStory();
				this.$router.push({ name: "set_up_password" });
			} catch (e) {
				this.$message.error(e);
			}
		}
	},
	created() {
		this.initStories();
	}
};
</script>